"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  home: {
    ok: 'OK',
    No: 'No.',
    title: 'Home',
    description: 'This is the home page.',
    welcome: 'Welcome to the home page!',
    importOne: 'Deliverable Date & Freight',
    importTwo: 'Inbound Cargo',
    importThree: 'Delivery Order Appoint',
    importFour: 'Appointment History',
    importFive: 'Delivery Order Appoint (Shanghai)',
    importSix: 'Appointment History (Shanghai)',
    controlOne: 'Booking',
    controlTwo: 'My Booking',
    controlThree: 'Booking (JP)',
    controlFour: 'Booking History (JP)',
    controlFive: 'VGM Declare',
    controlSix: 'DG Cargo Declare',
    controlSeven: 'New Manifest EDI',
    controlEight: 'EDI Feed Back',
    controlNine: 'My Booking Template',
    infoOne: 'Cargo Tracking',
    infoTwo: 'Release Status',
    infoThree: 'Dangerous Cargo&Special Container',
    infoFour: 'Surcharge&Local Charge',
    infoFive: 'Carbon Calculator',
    infoSix: 'Document Download',
    containerOne: 'Inbound Container Fee',
    containerTwo: 'Container net weight inquiry',
    containerThree: 'Demurrage&Detention Tariff',
    containerFour: ' DEM/DET Calculation',
    vesselOne: 'Shipping Schedule',
    vesselTwo: 'Vessel Movement',
    vesselThree: 'Ship information',
    blNo: 'B/L NO.',
    blNoMultiple: 'Query multiple, please separate them with commas.',
    bkNoMultiple: 'Query multiple, please separate them with commas.',
    registerNewAccount: 'Register New Account',
    registerText: 'Please fill in personal information',
    account: 'Account',
    userName: 'User name',
    passWord: 'Password',
    surePassWord: 'Confirm password',
    email: 'E-mail',
    emailPlus: 'E-mail (Can receive bill of lading sample email)',
    agreeRegisterText: 'Agree to the terms of registration and use of SITC SHIPPING',
    registerAgreement: 'Terms of Registration',
    bookingAgreement: 'Terms of Web Booking',
    agreement: 'Read and Agree',
    messAgreeRegisterText: 'Please enter your account number. Please agree to SITC SHIPPING registration and use terms first!',
    messageOne: 'Please enter your password again',
    messageTwo: 'The two passwords do not match!',
    messageThree: 'Please enter the correct email address',
    messageFour: 'Please enter the correct user name',
    messageSix: 'Please enter the  email',
    newPassWord: 'New password',
    captchaCode: 'Verification code (half-width alphanumeric)',
    buttonClose: 'Close',
    sentEmail: 'Send Email',
    registerAccount: 'Register account',
    forgetPassword: 'Forget password',
    forgetAccount: 'Forget account',
    rembermer: 'Remember password',
    haifeng: 'Haifeng staff',
    portOfDeparture: 'POL',
    destinationPort: 'POD',
    portOfDepartureBySort: 'POL=>POD',
    through: 'Direct',
    transfer: 'Transfer',
    portofTransshipment: 'POT',
    search: 'Search',
    select: 'Please Select',
    reset: 'Reset',
    connection: "Local Contact",
    route: 'Lane',
    vesselAndVoyage: 'VVL',
    sailingTime: 'POL ETD',
    arrivalTime: 'POD ETA',
    operate: 'Action',
    startShipment: 'Start shipment',
    aimPort: 'Destination',
    bookingPromotion: 'BK Promotion',
    departure: 'Estimated departure time',
    arrival: 'Estimated arrival time',
    home: 'Home',
    schedule: 'Schedule',
    information: 'Information',
    equipment: 'Equipment',
    inBound: 'Inbound',
    booking: 'Booking',
    suggest: 'Complaints and Suggestions',
    branch: 'Branch',
    registerIndex: 'Register',
    noLogin: 'Not Login',
    setOut: 'depart',
    arrive: 'Arrive',
    vesselName: 'Vessel',
    filter: 'Filter',
    vesselNameCopy: 'Vessel Name',
    submitRegister: 'Submit Register',
    messAccountNo: 'Please enter your account number',
    messRegisterSuccess: 'Congratulations on successfully registering your account. Please go to your email to activate your account. After the account is activated, you can log in and use it. ',
    changePasswordTip: 'You are currently using an old online booking account. To log in to the new online booking account for the first time, you need to reset your password in order to continue with the following operations',
    readWebOnlineTerm: 'Read the online terms of use',
    messagePass: 'The password must contain 8 to 30 characters, Must contain uppercase letters+lowercase letters+numbers+special symbols (! @ # ￥%&)',
    modifyPasswordSuccess: 'The modification was successful. Please log in to the system again. Thank you!',
    messagePassAccount: 'The user name must be 5 to 20 characters of letters and numbers, and can only contain uppercase letters, and must start with a letter',
    messRegisterFail: 'Registration failed',
    mobilePhone: 'Booking Tel',
    contactCustomer: 'Booking Person',
    people: 'Actual Shipper',
    bkNo: 'BK NO.',
    bookingType: 'BK Type',
    transportationTerms: 'Transport Terms',
    paidPalce: 'Paid Place',
    paidType: 'Pay Type',
    documentType: 'Bill Type',
    documentNo: 'SWL Agreement',
    agreementNo: 'Pre Agmt No',
    ft: 'Free Time No',
    sales: 'Sales',
    stuffType: 'Stuff Type',
    cargoType: 'Cargo Type',
    customsType: 'CUSTOMS TYPE',
    por: 'POR',
    pol: 'POL',
    pod: 'POD',
    del: 'DEL',
    customerInfoPort: 'Port：',
    customerInfoPortType: 'Port Type：',
    customerInfoCustomerType: 'Customer Type：',
    customerInfoRequiredField: 'Required Field：',
    customerInfoShouldInclude: 'Should Include：',
    canNotNull: 'Can not be null!',
    customerInfoPortFrom: 'PORT FROM',
    customerInfoPortTo: 'PORT TO',
    address: 'ADDRESS',
    saveValidCustomerInfoNotification: 'Information',
    tips: 'Tips：',
    compulsion: 'Compulsion：',
    continueSave: 'Continue Save',
    cargoInfo: 'Cargo Information',
    fwdDesc: 'Cargo Desc',
    actualGrossWeight: 'Gross Weight(KG)',
    dropTitle: 'Precontainer',
    terminalInfo: 'CY Information',
    terminalInfoPrevious: 'CY Information(Previous version)',
    terminalInfoCurrent: 'CY Information(Current version)',
    containerType: 'Container Type',
    quantity: 'Quantity',
    retureDate: 'Return Date',
    pickUpDate: 'Pick Up Date',
    returnDepot: 'Return Terminal',
    pickUpDepot: 'CY Depot',
    pickupYard: 'Pick Up CY',
    returnYard: 'Return CY',
    additionalCharges: 'Surcharges',
    additionalChargesPrevious: 'Surcharges(Previous version)',
    additionalChargesCurrent: 'Surcharges(Current version)',
    bKDocumentPrevious: 'BK Document(Previous version)',
    bKDocumentCurrent: 'BK Document(Current version)',
    feeItem: 'Fee Item',
    payModel: 'Pay Type',
    documentNoNew: 'Document No',
    packageCount: 'Package Count',
    validateFee1: 'Row ',
    validateFee2: ' in Surcharges, Fee Item ',
    validateFee3: ', already exists!',
    packageType: 'Package Type',
    weight: 'Weight',
    useTimes: 'Use Times',
    isSplit: 'Is Split',
    tsFlag: 'Transfer Info',
    addBySchedule: 'Add Transfer Info By Schedule',
    tsRoute: 'Transfer Info',
    dgCheckFlag: 'Hazardous Cargo',
    selectVesselTime: 'Choose Vessel',
    rfCheckFlag: 'Reefer',
    akCheckFlag: 'Special Container Info',
    socCheckFlag: 'SOC',
    hgCheckFlag: 'HANGERS GARMENTS',
    addTransfer: 'Add Transfer',
    tripNumber: 'Trip No',
    portFrom: 'Port From',
    portTo: 'Port To',
    voyageLeg: 'Voyage Leg',
    carrier: 'Carrier',
    lineType: 'Line Type',
    serviceLineCode: 'Service Line Code',
    vesselCode: 'Vessel Code',
    voyageNo: 'Voyage No',
    saillingDate: 'Sailling Date',
    etd: 'Etd',
    polYard: 'Pol Yard',
    podYard: 'Pod Yard',
    imoClass: 'IMO Class',
    unNo: 'UN No.',
    commodityName: 'Commodity Name',
    unit: 'Unit',
    maxTemperature: 'Max Temperature',
    minTemperature: 'Min Temperature',
    airvent: 'Ventilation',
    humidness: 'Humidity',
    akGrossWeight: 'Gross Weight(KG)',
    akNetWeight: 'Net Weight(KG)',
    quantityNew: 'Quantity',
    commodityNameNew: 'Commodity Name',
    overFront: 'Over Front*Over After*Over Portside*Over Starboard*Over High(CM)',
    isWallsFold: 'Is Walls Fold',
    isPointCover: 'Is Point Cover',
    stowageRequired: 'Stowage Required',
    specialLoadRequired: 'Special LoadRequired',
    securingMethod: 'Securing Method',
    cellphone: 'Cell phone',
    oceanFreight: 'Freight',
    direction: 'Direction',
    returnToPort: 'Return To Port Code',
    returnToPortName: 'Return To Port Name',
    fullEmptyType: 'Full/Empty Type',
    containerSize: 'Container Size',
    contactPerson: 'Contact Person/OPR Code',
    rope: 'Rope',
    ties: "Ties",
    type: 'Type',
    remark: 'Remark',
    priceRemark: 'Price Remark',
    buttonAdd: 'Save and Submit',
    buttonCopy: 'Batch Copy',
    back: 'Reject',
    priceRemarkInfo: 'Please indicate OF price for market prices, long-term contract number for long-term contracts, FOB number for FOB goods.',
    buttonSaveCopy: 'Save Draft',
    placehold: 'Please enter content',
    packageDesc: 'Package Group',
    property: 'Proper Shipping name',
    componentDesc: 'Chemical Name',
    emergencyTelNo: 'Emergency Tel',
    imoQuantity: 'Quantity',
    imoGrossWeight: 'Gross Weight(KG)',
    imoNetWeight: 'Net Weight(KG)',
    flashPoint: 'Flash Point',
    rateBase: 'Rate Base',
    isPolutionFlag: 'Is Marine Pollutant',
    packagingCode: 'Packaging Code',
    cargoSize: 'Size(m~3)',
    temperatureOne: 'Temperature',
    intakeNum: 'Vent',
    contactName: 'Contact Name',
    contactNumber: 'Contact Number',
    contactTypeCode: 'Contact Type Code',
    approveKey: 'Approve Key',
    emergencySeq: 'EMS CODE',
    unitTitle: 'Length*Width*Height(CM)',
    startTime: 'Start Date',
    endTime: 'End Time',
    form: 'To',
    // remark:'Remark',
    bookingStatus: 'Status',
    sureBooking: 'Sure Booking',
    editBooking: 'Edit Booking',
    cancelBooking: 'Cancel Booking',
    waitBooking: 'Wait Booking',
    lockBooking: 'Lock Booking',
    unlockBooking: 'Unlock Booking',
    draftBooking: 'Draft Booking',
    applyBooking: 'Applying',
    recordBooking: 'Record Booking',
    draftRecordBooking: 'Draft Record Booking',
    submit: 'Commit',
    batchCommit: 'Batch Commit',
    lookOne: 'View/Modify BK',
    lookEdit: 'Modify',
    look: 'View/Edit',
    supply: 'SuplookOneSupplyply',
    more: 'More',
    bookMyOne: 'Release Apply',
    bookMyTwo: 'Vessel Voyage Adjust',
    bookMyThree: 'CY Cut Time',
    bookMyFour: 'Document Import(KR)',
    bookMyFourCopy: 'Document Excel(KR)',
    bookMyFive: 'Load Formate',
    bookMySix: 'Container & VGM Excel Import',
    bookMySeven: 'Free Time View',
    bookMyEight: 'Combine Check',
    bookMyNine: 'Cargo Tracking',
    sureButton: 'Confirm',
    saveMessage: 'Save Success',
    failMessage: 'Save Fail',
    departureTime: 'Departure Time',
    newDepartureTime: 'ETD Latest',
    discharge: 'Discharge',
    editTime: 'Update Time',
    manifestType: 'B/L Type',
    blNoType: 'B/L Type',
    totalNo: 'Total No',
    boxType: 'Cntr Type&Qty',
    saveSuccess: 'Save Success',
    listModel: 'List Style',
    cardModel: 'Card Style',
    operateSuccess: 'Operate Success',
    warning: 'Please select one record to modify',
    releaseWay: 'Delivery Method',
    releaseApply: 'Apply',
    releaseView: 'Letter of Guarantee View',
    porFormat: 'POR Format',
    polFormat: 'POL Format',
    podFormat: 'POD Format',
    delFormat: 'DEL Format',
    logStatus: 'Letter of Guarantee Status',
    logInfomation: 'Letter of Guarantee Information',
    deliveryDocumentMethod: 'Bill Type',
    releaseStatus: 'Release Status',
    deleteCheck1: 'Confirm to delete',
    deleteCheck2: 'data',
    toast0: 'The container type in Special Container Info should match that in Precontainer!',
    toast1: 'The container type in HANGERS GARMENTS should match that in Precontainer!',
    toast2: 'bkNo is required',
    toast3: 'blNo is required',
    toast4: 'Commodity Name is required',
    toastOne: 'When the cargo type is HG-1(ONE BAR) or HG-2(TWO BARS), please check the HANGERS GARMENTS!',
    toastOne_1: 'When the HANGERS GARMENTS is checked, the cargo type needs to be HG-1(ONE BAR) or HG-2(TWO BARS)!',
    toastTwo: 'The container type is FR or OT or OH or FH, please check the Special Container Info!',
    toastTwo_1: 'When the Special Container Info is checked, the container type needs to be FR or OT or OH or FH!',
    toastThree: 'When the cargo type is HAZARDOUS or HAZARDOUS or EMPTY&DG, please check Hazardous Cargo!',
    toastThree_1: 'When the Hazardous Cargo is checked, the cargo type needs to be HAZARDOUS or HAZARDOUS or EMPTY&DG!',
    toastFour: 'When the cargo type is REEFER, please check the Reefer!',
    toastFour_1: 'When the Reefer is checked, the cargo type needs to be REEFER!',
    toastFive: 'The frozen goods type in the unloading paper can only select HR and RF box types!',
    toastSix: 'Additional fees and miscellaneous fees cannot be empty!',
    toastSeven: 'When the type is promotion, the number of carton information can only be 1!',
    toastEight: 'When the type is promotion, the number of carton information can only be 1!',
    toastNine: 'Inconsistency in number of Package Count(Quantity), Gross Weight(Weight), and Size between Cargo Information and all Container info',
    copyNumber: 'Split Num',
    copyTwo: '+Number',
    copyThree: '+Letter',
    copyFour: '*+Letter',
    copySubimtButton: 'Batch Copy',
    copySubimtButtonOpen: 'Batch Copy(Open)',
    loginSuccess: 'Login Success',
    noLoginMessage: 'Please login first',
    sentEmailSuccess: 'Email sent successfully',
    sentEmailFail: 'Email sent failed',
    userError: 'The user name cannot be repeated, it can be English or Chinese, and the length cannot exceed 100',
    total: 'Total',
    terminalInfoOne: 'Terminal Code',
    terminalInfoTwo: 'Terminal Name',
    terminalInfoThree: 'Terminal Name(EN)',
    other: 'Other',
    country: 'Country/Region Code',
    portCodeOne: 'Port Code',
    portName: 'Port Name',
    portCodeTwo: 'Port Name(CN)',
    closeWaring: 'Please remember to save~',
    closeWaringTwo: 'Close',
    close: 'Close',
    copyOne: 'Copy',
    ftExport: 'FT Export',
    ftapply: 'FT Apply',
    reportOut: 'Split BL',
    reportOutOne: 'Combine BL',
    reportOutTwo: 'Split Booking',
    reportOutThree: 'Quick Split',
    reportOuFour: 'Quick Combine',
    feedcheck: 'S/I Compare',
    withdrawal: 'Withdraw Booking',
    copySuccess: 'Copy successfully',
    logOut: 'Log Out',
    logOutMessage: 'Are you sure you want to log out?',
    logOutSuccess: 'Log Out Success',
    sumit: 'Sure',
    chargeCode: 'Charge Code',
    chargeName: 'Charge Name',
    chargeNameCn: 'Charge Name(Cn)',
    submitSuccess: 'Submit Success',
    closequxiao: 'Cancel',
    nowAdjust: 'Adjust immediately',
    consignerInfo: "Shipper's information",
    consignerName: "Shipper Name",
    consignerAddress: "Shipper Address",
    consignerCountry: 'Country/Region',
    consignerPhone: 'Tel',
    consignerFax: 'Fax',
    consignerEmail: 'E-Mail',
    consignerEnterpriseCode: 'Enterprise Code',
    consignerAEOCode: 'AEO Code',
    consignerReceiveInfo: 'Consignee information',
    consignerReceive: 'Consignee Name',
    consignerReceiveAddress: 'Consignee Address',
    notifierCity: 'City',
    notifierProvince: 'Province',
    notifierPostalCode: 'Postal Code',
    notifierInfo: 'Notify 1 Information',
    notifierName: 'Notify 1 Name',
    notifierAddress: 'Notify 1 Address',
    notifierInfoTwo: 'Notify 2 Information',
    notifierNameTwo: 'Notify 2 Name',
    notifierAddressTwo: 'Notify 2 Address',
    connetName: 'Contact Name',
    connetPhone: 'Contact Telephone ',
    connetEmail: 'Contact Email',
    connetFax: 'Contact Fax',
    shippingMark: 'Shipping Mark',
    commodityCode: 'Commodity Code',
    commodityNameOne: 'Commodity Name',
    packageDescOne: 'Package Desc',
    docCommodity: 'Doc Commodity',
    boxInfo: 'Container info',
    containerNo: 'Container No',
    sealNo1: 'Seal No',
    overWeight: 'Weight (KG)',
    cntrSize: 'Size (CBM)',
    overLeft: 'Over Portside(CM)',
    overRight: 'Over Starboard(CM)',
    overHeight: 'Over High(CM)',
    overForeward: 'Over Front(CM)',
    overAftward: 'Over After(CM)',
    socReture: 'SOC Return',
    vgmTitle: 'VGM Container Info',
    vgmPeople: 'PIC Signature',
    vgmTobu: 'Synchronous information',
    titleOne: '《交通运输部关于执行《1974年国际海上人命安全公约》第VI/2条2015年修正案的通知》',
    titleTwo: '《载货集装箱累加计算法重量验证指南》',
    // titleOne:'《Notice of the Ministry of Transport on the Implementation of the 2015 Amendment to Article VI/2 of the International Convention for the Safety of Life at Sea, 1974》',
    // titleTwo:'《Guide to weight verification for the cumulative calculation of cargo containers》',
    cargoTypeCode: 'Cargo Type',
    containerStatus: 'Container Status',
    cargoTypeName: 'Cargo name',
    cargoTypeNameCn: 'Cargo name (CN)',
    saillingDateOne: 'Sailing Date',
    departureTimeOne: 'ETD Org',
    supplyEdit: 'MODIFY',
    lookOneSupply: 'S/I/Modify',
    location: 'VGM Location',
    vgmGrossWeight: 'VGM Weight',
    vgmScale: 'Weight Scale',
    vgmDate: 'VGM Date',
    vgmMethod: 'VGM Method',
    selectFile: 'Select file',
    selectFileMessage: 'Only excel files can be uploaded',
    selectOneFile: 'Only one file can be uploaded. \n If there are multiple files, please organize them into one file before uploading.',
    selectSubmit: 'submit',
    DownloadExcelTemplate: 'Download Template',
    releaseViewUpload: 'Letter of Guarantee Upload',
    uploadTitle: 'Upload file',
    downloadSuccess: 'Download successfully',
    applyNo: 'Apply No',
    agreementNoOne: 'Agreement No',
    approvedNo: 'Approval No',
    ftIsAccepted: 'Status',
    receipt: 'POR',
    destination: 'DEL',
    commodity: 'Commodity',
    containerVolume: 'Container Type & Quantity',
    applyReason: 'Apply Reason',
    expectedDeliveryTime: 'Estimated Time of Delivery',
    shipperName: 'Shipper',
    consigneeName: 'Consignee',
    isDG: 'Business Type',
    rfPlugDays: 'RF Plug Days',
    containerTypeCode: 'Container Type',
    demuFreeDays: 'Method 1',
    detenFreeDays: 'Method 1',
    backCaoga: 'Return Draft',
    ftapplyMessage: 'Application is successful, please wait for approval',
    ftapplyMessageCopy: 'Return to draft successful',
    vesselNameCn: 'vessel Name(CN)',
    expandOthers: 'Expand/Collapse',
    packUpOthers: 'Pack other information',
    packageCode: 'Packaging type',
    packageName: 'Packaging name',
    packageNameCn: 'Package Type Name (CN)',
    customerTypeOne: 'The shipper cannot be empty',
    customerTypeTwo: 'The consignee cannot be empty',
    customerTypeThree: 'Notifier 1 cannot be empty',
    customerTypeFour: 'Notifier 2 cannot be empty',
    customerTypeFive: 'When the unloading port is CNYNT or CNTXG,Shipper,Consignee,Notify Country cannot be empty',
    customerTypeSix: 'When the unloading port is CNYNT or CNTXG, Shipper,Consignee,Notify Tel can not be empty!',
    customerTypeSeven: 'When the unloading port is CNYNT or CNTXG, Shipper,Consignee,Notify Enterprise Code can not be empty!',
    customerTypeTH1: 'When the pol is a port in Thailand,Shipper,Consignee,Notify Country cannot be empty',
    customerTypeTH2: 'When the pol is a port in Thailand,Shipper,Consignee,Notify Tel can not be empty!',
    customerTypeTH3: 'When the pol is a port in Thailand,Shipper,Consignee,Notify Enterprise Code can not be empty!',
    customerTypeTH4: 'When the pol is a port in Thailand,the Consignee information Contact Name cannot be empty',
    customerTypeTH5: 'When the pol is a port in Thailand,the Consignee information Contact Email cannot be empty',
    customerTypeCN1: 'When the unloading port in China, the Consignee information Tel cannot be empty',
    customerTypeCN2: 'When the unloading port in China, the Consignee information Enterprise Code cannot be empty',
    customerTypeCN3: 'When the unloading port in China, the Consignee information E-Mail cannot be empty',
    customerTypeCN11: 'When the unloading port in China, the Notify 1 Information Tel cannot be empty',
    customerTypeCN12: 'When the unloading port in China, the Notify 1 Information Enterprise Code cannot be empty',
    customerTypeCN13: 'When the unloading port in China, the Notify 1 Information E-Mail cannot be empty',
    warningJustOne: 'Only one piece of data can be selected',
    myTemplate: 'Template Name',
    createTime: 'Create Time',
    ftapplyMessageValid: "'Vietnam's bill of lading does not support the application!'",
    ftapplyMessageValidOne: 'Application is not supported without box information!',
    selectFileWaring: 'Please upload file',
    uploadTitleSuccess: 'File uploaded successfully',
    cargoTypeCodeOne: 'Cargo Type',
    revocationConfirmMessage: 'Withdraw booking or not?',
    revocationMessage: 'Booking successfully withdrawn',
    checkTitle: 'Primary single point single check',
    statusMessage: 'The operation cannot be performed in the current state',
    copySix: 'System numbering',
    getLockByDocMessage: 'The ship has been documented and locked, cannot be modified',
    cancelBookingMessage: 'Booking cancelled successfully',
    cancelBookingMessageError: 'Booking Cancellation Failed, BK NO.：',
    cancelBookingConfirmMsg: 'Cancel booking or not?',
    uploadFile: 'Attachment',
    fileName: 'filename',
    uploadTime: 'Upload time',
    actions: 'operate',
    fileUploadOne: 'Upload',
    fileTitle: 'attachments',
    deleteFile: 'delete',
    downFile: 'download',
    fileMessageTwo: 'Only one file can be uploaded, please delete it first',
    deleteMessage: 'Are you sure you want to delete the selected data?',
    deleteSuccess: 'Delete Success',
    numberLarge2: 'At least 2 votes are required, and no more than 100 votes are allowed',
    cancelButton: 'Cancel',
    addTicket: 'Split line',
    topBl: 'Top B/L',
    temperature: 'Temp',
    terminalInfoMessage: 'Please select the terminal information first',
    deleteTip: 'Are you sure you want to delete the selected data?',
    toastTen: 'Please select the terminal information first!',
    tsPlus: 'if Transfer Info is ticked,  it must be more than one record.',
    toastEleven: 'Please select the port information first!',
    viewLook: 'Preview',
    bookCancel: 'Cancel Booking',
    reportOutWarning: 'Only supports the operation of consolidation and separation of bills of lading with confirmed booking, unlocking and consolidation application status.',
    reportOutOneWarning: 'Only supports splitting and merging of bills of lading with confirmed booking, unlocking, and consolidation application status',
    reportOutTwoWarning: 'Only supports the operation of splitting of B/L with confirmed booking, unlocking and consolidation application status.',
    onlyOneOrNullWarning: 'Please select one record or leave it unchecked in order to use this feature',
    cancelSuccess: 'Cancel Success',
    applySuccess: 'Apply Success',
    splistWanning: 'Split and merge order has been operated for this ticket, and it is not possible to do so',
    copyCountRequire: 'Please input the number of copies',
    bkNoRequire: 'Please input the  bkNo',
    blNoRequire: 'Please input the  blNo',
    blNoRequire2: 'BlNo cannot be empty',
    deleteRequireLengh: 'Sub-BL must be at least two,please re-enter!',
    basicInfoPreviousVersion: 'Basic Information (Previous version)',
    basicInfoNextVersion: 'Basic Information (Current version)',
    consignerInfoPrevious: "Shipper's information(Previous version)",
    consignerInfoCurrent: "Shipper's information(Current version)",
    consignerReceiveInfoPrevious: 'Consignee information(Previous version)',
    consignerReceiveInfoCurrent: 'Consignee information(Current version)',
    notifierInfoPrevious: 'Notifier 1 information(Previous version)',
    notifierInfoCurrent: 'Notifier 1 information(Current version)',
    notifierInfoTwoPrevious: 'Notifier 2 information(Previous version)',
    notifierInfoTwoCurrent: 'Notifier 2 information(Current version)',
    cargoInfoPrevious: 'Cargo Information(Previous version)',
    cargoInfoCurrent: 'Cargo Information(Current version)',
    dropTitlePrevious: 'Drop Box Information(Previous version)',
    dropTitleCurrent: 'Drop Box Information(Current version)',
    boxInfoPrevious: 'Box info(Previous version)',
    boxInfoCurrent: 'Box info(Current version)',
    hsCodeOne: 'POL belongs to KR, HS CODE(KR), HS CODE(CN), HS CODE(JP) cannot be empty',
    hsCodeTwo: 'POL belongs to KR, HS CODE(KR), HS CODE(CN), HS CODE(JP) cannot be empty',
    hsCodeThree: 'POL belongs to KR, HS CODE(KR), HS CODE(CN), HS CODE(JP) cannot be empty',
    hsCodeFour: 'HS CODE cannot be empty',
    emailRequire: 'Please input the email',
    commodityNameCn: 'Commodity Name(EN)',
    uploadFiveInfo: 'The uploaded file cannot exceed 5MB',
    uploadSixInfo: 'The file name is too long, please control within 40 characters!',
    ftboxMessage: 'The ventilation unit must be %, CBM/H, or CLOSED',
    ftboxMessageOne: 'The total weight includes: cargo weight, binding material weight, box weight',
    bookEta: 'POL ETD Org',
    //ETA
    bookEtd: 'POL ETD Latest',
    //ETD
    bookAtd: 'POD ETA',
    //ATD
    exportTitle: 'Export',
    exportMessage: 'Export Success',
    viewTemplate: 'View Template',
    sOView: 'SO View',
    previewFailed: 'Preview failed, please contact the system administrator.',
    validateTemperature: 'Incorrect temperature format',
    validateIntakeNum: 'The vent unit must be "%", "CBM/H", or "CLOSED"',
    validateHumidity: 'The humidity unit must be "%"',
    viewFail: 'The current data cannot be previewed',
    selectSort: 'Select columns',
    warningRelease: 'VVL or B/L NO. can not be all empty!',
    passWordError: 'The password contains a maximum of 30 characters',
    statusPrintMessage: 'View is not supported',
    containerManager: 'Container Manager',
    detailVerifyMessage: 'The current data is not the data that needs to be verified',
    sliderText: 'Drag the slider to complete the puzzle verification',
    searchMessage: 'Booking number, B/L number, ship name/voyage and sailing time cannot all be blank, one of them must be filled in.',
    failText: 'Verification failed, please try again',
    successText: 'Verification passed!',
    rateBaseOne: 'Rate Base',
    etdTo: 'To ETA',
    warningReleaseView: 'Please select at least one data',
    warningLogStateUpload: 'Send Failure. The selected data has passed and is not allowed to be uploaded again.',
    containerVolumeOne: 'Container Volume',
    serviceSupport: 'Help Center',
    contactUs: 'Contact Us',
    helpCenter: 'User Registration',
    localContact: 'Local Contact',
    complaintCenter: 'Complaint Center',
    blNoTypeOne: 'B/L OP Mode',
    dgCheckFlagOne: 'DG',
    saveSuccessSubmit: 'Save and submit successfully',
    ourTitle: 'ABOUT US',
    sailingTimePol: 'POL',
    sailingTimeEtd: 'ETD',
    sailingTimePod: 'POD',
    sailingTimeEta: 'ETA',
    toastNumber: 'Sequence number incoherent in journey information!',
    toastNumberOne: 'The sequence number of the journey information cannot be empty!',
    toastOneFont: 'The precontainer cannot be duplicated, and the quantity of duplicate data need be accumulated by yourself.',
    lookDetail: 'Display Detail',
    hideDetail: 'Hide Detail',
    dangerousGoodsMessage: 'When the IMO Class of dangerous goods starts with 3, the flash point and flash point unit of dangerous goods must be filled in',
    messageFourOne: 'There has to be a Ocean line',
    helpNew: 'Help',
    annunciation: 'Annunciation',
    evenlyDivide: 'Evenly divide',
    countInfo: 'Count',
    totalInfo: 'Total',
    displayButton: 'Shipper/Consignee',
    hideButton: 'Shipper/Consignee',
    displayOpen: 'Show',
    displayClose: 'Hide',
    applicationRules: 'Application rules:\n1.The following 5 countries can only apply detention,and don’t fill in the demurrage.\nAfter approve, DEM/DET can be combined to use.\nCountries：Indonesia / India / BangladeshR / Russia Far East / Myanmar\n2.Just fill in the numbers when applying,and don’t fill in the unit(天/DAYS）',
    successRelease: 'Release success',
    KRXXXreleaseApply: 'SEA WAYBILL and ORIGINAL cannot be applied to Korea booking.',
    seaWaybillValid: 'Delivery Method【SEA WAYBILL】 can be applied only when bill type is SEA WAYBILL!',
    cargoDescMessage: 'The cargo contains sensitive goods:',
    cargoDescMessage1: ',continue to save or not?',
    saveTip: 'Tips',
    warningJustOneTwo: 'At least 2 votes are divided, and no more than 100 votes are allowed',
    selectOrder: 'Top BL',
    order: 'Order',
    combinMessage: 'The single operation succeeded',
    closeCombin: 'Cancel Combine',
    sureCombin: 'Confirm Combine',
    selectOrdermessage: 'Please select the master order first',
    cancelBookingMessageCombin: 'Only the master order that supports the single order cancels the single order',
    exportCostSlipUpload: 'Export Fee Confirmation',
    appointmentHistorySh: 'In Document Upload',
    bittonTop: 'Same Consignee',
    newToday: 'Today',
    pleaseEnterKeyWord: 'POL and POD is required, (Vessel Code/Vessel Name+Voyage No+Voyage Leg) and Sailing Date are alternative',
    statusCancelMessage: 'Only POL = CNSHK/CNNSA/CNTAG/Thailand can be used',
    cancellation: 'Split Cancel',
    rateBaseCopy: 'Temperature Degree',
    cancelBookingChangeVVLMessage: 'Vessel Voyage Adjust cannot be used if the booking is canceled.',
    bookSureCanUse: 'Container & VGM Excel Import can only be used when Status is ACCEPTED or BKG UNLOCKED',
    checkCargoGrossWeight1: 'BK Type / Cargo type is not Empty, Gross weight cannot be zero “0”',
    checkCargoGrossWeight2: 'BK Type / Cargo type is Empty, please confirm whether the gross weight zero “0” is correct.',
    hsCodeCnNotNull: 'HS CODE is not empty',
    hsCodeJpNotNull: 'HS CODE(JP) is not empty',
    hsCodeNotNull: 'HS CODE(KR) is not empty',
    chargeInfo: 'Freight rate information',
    chargeInfoTitle: 'Freight Rate(General Purpose)',
    chargeInfoTips1: 'One Container in One Booking',
    chargeInfoTips2: 'Teu Upper Limit in One Booking',
    annunciation1: 'Annunciation',
    containerTypeNotTrue: 'The container type in precontainer can only be input with that exists in the freight rate!',
    containerLimitNotTrue: 'The total teu in precontainer exceeds the maximum limit value ',
    preLockLabel: 'Pre Lock',
    preLock: 'Prewired Lock',
    prewiredLock: 'Pre Lock',
    blLock: 'B/L Lock',
    downloadCustomsDeclaration: 'Download Customs Declaration',
    CNXMNPreLock: 'Only when POL is CNXMN and there is container information and the booking status is accepted or BKG unlocked, Pre Lock is available!',
    CNXMNBlLock: 'Only when POL is CNXMN and there is container information and the booking status is accepted or BKG unlocked, B/L Lock is available!',
    CNXMNDownloadCustomsDeclaration: 'Only when POL is CNXMN and pre locked, Download Customs Declaration is available!',
    validateKRXXXBKDocument: 'BK Document must input!'
  },
  Announcement: {
    title: 'Notice',
    text1: 'Dear customer,',
    text2: 'The current platform is the new e-commerce platform of SITC Shipping. The specific online functions and scope are as follows:',
    text3: '1. All public query functions',
    text4: 'a. No login required function: ',
    text4_1: 'shipping schedule, vessel movement, cargo tracking, etc.',
    text5: 'b. Registration and login required (email activation, but no authentication required): ',
    text5_1: 'VGM declare, etc.',
    text6_1: '2. Online Booking (registration and authentication login required): Booking customers in China (Shenzhen, Qingdao, Nansha, Yangpu, Dalian, Yantai, Tianjin, Rizhao, Weifang, Ningbo, Shanghai, Taicang, Zhangjiagang, Qinzhou, Hong Kong), Thailand, Vietnam, Malaysia, South Korea, Japan, Indonesia',
    text6: ' will use it first. Others continue to use the functions of old platform and the specific launch time will be notified separately.',
    text7_1: '3. Inbound Delivery Order Appoint (registration and authentication required): Inbound Delivery Order Appoint customers in  China (Shenzhen, Qingdao, Tianjin, Dalian, Nansha, Yangpu, Ningbo, Shanghai) ',
    text7: ' will use it first. Others continue to use the functions of old platform and the specific launch time will be notified separately.',
    text8: 'Note: The regular customers of Online Booking and Inbound Delivery Order Appoint can log in with your original account. The first login will prompt you to reset your password. As new customer, please register and apply for authentication approval first.'
  },
  questionNaire: {
    clickEnter: 'Click to enter details',
    title: '2025 SITC Customer Needs Questionnaire',
    text1: 'Dear Customer',
    text2: 'Thanks for your support to SITC!',
    text3: 'Please fill in this questionnaire to let us know your evaluation of our service quality. We will continuously improve our service quality based on your opinions and suggestions. ',
    text4: 'Website Link to fill',
    text5: 'Press and hold below QR code to fill'
  }
};